
namespace Areas.Projects {
    "use strict";


    var tabItems = Areas.createTabsWithSameActionAndDifferentAreas("Index",
        [
            "Projects/Edit",
            "Inspections/List",
            "AreaRoom/Pivot",
            "NonCompliances/List",
            "Observations/List",
            "Anchorages/List",
            "Polarities/List",
            "Dailies/List"
        ]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }
}